import { internalApiClient } from '@/api/apiClient';
import endpoints from './endpoints';

export default {
  getConfig: async (params) => await internalApiClient.get(endpoints.get(), { params }),
};
